var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "360px",
    height: "360px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#36382E;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{display:none;}\n\t.st2{display:inline;fill:#E9E2C0;stroke:#36382E;stroke-width:2;stroke-miterlimit:10;}\n\t.st3{display:inline;fill:#F9F5E3;stroke:#36382E;stroke-width:2;stroke-miterlimit:10;}\n\t.st4{display:inline;fill:#D6C36A;}\n\t.st5{display:inline;fill:#F2EBCB;}\n\t.st6{fill:#F9F5E3;stroke:#36382E;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{fill:#F2EBCB;}\n\t.st8{fill:#E9E2C0;stroke:#36382E;stroke-width:2;stroke-miterlimit:10;}\n\t.st9{fill:#D6C36A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 180,
    cy: 174.2,
    rx: 91,
    ry: 89.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 155.77,
    cy: 145.01,
    rx: 24.23,
    ry: 23.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 223.22,
    cy: 171.31,
    rx: 22.75,
    ry: 23.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -103.1702 178.9482)",
    className: "st4",
    cx: 164.42,
    cy: 214.01,
    rx: 21.5,
    ry: 21.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M231.59,103.65c14.53,11.83,32.03,40.68,22.88,35.64c-53.23-29.34-80.5,26.12-69.86,48.46 c19.06,40.01,74.06,26.21,63.98,38.68c-61.77,76.42-171.03,26.07-159.78-67.71c9.09-75.74,81.35-75.06,84.07-75.03 C194.37,84.01,209.92,86.01,231.59,103.65z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 154.15,
    cy: 138.67,
    rx: 21.95,
    ry: 23.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 127.03,
    cy: 191.91,
    rx: 17.3,
    ry: 18.21
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.03,175.28c0-87.62,75.64-113.83,118.93-85.93c21.45,13.82,20.72,24.28,19.65,23.83 c-43.97-18.35-73.82,12.75-70.17,65.16c5.34,76.76,76.91,42.51,76.59,43.86c-14.34,61.03-134.26,61.74-144.48-33.72 C88.2,185.23,88.03,178.64,88.03,175.28z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 134.08,
    cy: 207.35,
    rx: 18.98,
    ry: 23.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 118.26,
    cy: 151.6,
    rx: 11.07,
    ry: 13.31
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158.11,78.03c52.22-4.03,70.87,28.06,71.8,30.8c0.38,1.11-44.82-11.83-79.17,15.87 c-24.08,19.41-22.24,61.35-8.77,83.24c32.61,52.99,88.91,21.92,88.31,23.81C214.83,280.7,90.8,289.04,80.72,172.53 C76.05,118.62,109.68,81.77,158.11,78.03z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 113.47,
    cy: 133.91,
    rx: 13.92,
    ry: 14.87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 97.56,
    cy: 163.65,
    rx: 7.96,
    ry: 8.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.11,78.03c52.22-4.03,70.87,28.06,71.8,30.8c0.38,1.11-44.82-11.83-79.17,15.87 c-24.08,19.41-22.24,61.35-8.77,83.24c32.61,52.99,88.91,21.92,88.31,23.81C214.83,280.7,90.8,289.04,80.72,172.53 C76.05,118.62,109.68,81.77,158.11,78.03z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 113.47,
    cy: 133.91,
    rx: 13.92,
    ry: 14.87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 97.56,
    cy: 163.65,
    rx: 7.96,
    ry: 8.48
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.55,103.77c-15.22,11.9-33.55,40.91-23.96,35.83c55.75-29.5,84.31,26.26,73.17,48.73 c-19.96,40.23-77.57,26.36-67.01,38.9c64.69,76.85,179.13,26.22,167.35-68.08c-9.52-76.16-85.21-75.48-88.05-75.44 C159.52,84.01,143.24,86.03,120.55,103.77z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 201.65,
    cy: 138.98,
    rx: 22.99,
    ry: 23.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 230.05,
    cy: 192.51,
    rx: 18.12,
    ry: 18.31
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.92,177.73c0-86.2-84.51-111.99-132.88-84.54c-23.96,13.6-23.15,23.89-21.95,23.45 c49.12-18.05,82.47,12.55,78.4,64.11c-5.97,75.51-85.93,41.82-85.57,43.15c16.02,60.04,150,60.74,161.42-33.17 C270.73,187.52,270.92,181.03,270.92,177.73z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 219.47,
    cy: 209.28,
    rx: 21.2,
    ry: 23.03
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 237.14,
    cy: 154.44,
    rx: 12.37,
    ry: 13.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.13,82.03c-51.53-3.9-69.93,27.16-70.84,29.82c-0.37,1.08,44.22-11.45,78.12,15.36 c23.76,18.79,21.95,59.39,8.65,80.58c-32.18,51.29-87.72,21.22-87.14,23.05c15.24,47.39,137.62,55.46,147.57-57.32 C276.1,121.33,242.92,85.65,195.13,82.03z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 239.17,
    cy: 136.13,
    rx: 13.74,
    ry: 14.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 254.87,
    cy: 164.91,
    rx: 7.85,
    ry: 8.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M195.13,82.03c-51.53-3.9-69.93,27.16-70.84,29.82c-0.37,1.08,44.22-11.45,78.12,15.36 c23.76,18.79,21.95,59.39,8.65,80.58c-32.18,51.29-87.72,21.22-87.14,23.05c15.24,47.39,137.62,55.46,147.57-57.32 C276.1,121.33,242.92,85.65,195.13,82.03z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 239.17,
    cy: 136.13,
    rx: 13.74,
    ry: 14.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 254.87,
    cy: 164.91,
    rx: 7.85,
    ry: 8.21
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon7);
export default __webpack_public_path__ + "static/media/Moon7.f634a38d77e934bc816302f860d3f877.svg";
export { ForwardRef as ReactComponent };